import { Component, Input, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'nc-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.less']
})
export class PdfViewerComponent implements OnChanges, AfterViewInit, OnDestroy {
  /** pdf文件地址 */
  @Input() ncUrl: string = '';

  viewerUrl!: SafeResourceUrl;
  objectUrl!: SafeResourceUrl;
  useIframe: boolean = true;
  private messageListener: ((event: MessageEvent) => void) | null = null;
  private errorSubject = new Subject<any>();

  constructor(private sanitizer: DomSanitizer) {
    this.messageListener = (event: MessageEvent) => {
      // 检查消息类型
      if (event.data && event.data.type === 'iframe-error') {
        const errorData: any = event.data;
        this.errorSubject.next(errorData);
        if (errorData.message.includes('Promise.withResolvers is not a function') ||
          errorData.message.includes("Unexpected token '{'") ||
          errorData.message.includes("Unexpected token '('")) {
          console.log(errorData.message)
          //只在第一次错误时切换到 object 模式
          if (this.useIframe) {
            this.switchToObjectMode();
          }
        }
      }
    };

    window.addEventListener('message', this.messageListener);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ncUrl']) {
      this.updateViewerUrls();
    }
  }

  ngAfterViewInit() { }

  ngOnDestroy() {
    if (this.messageListener) {
      window.removeEventListener('message', this.messageListener);
    }
  }

  private updateViewerUrls() {
    // 组织 pdfjs viewer 方式url
    const iframeUrl = `assets/pdfjs-dist-build/web/viewer.html?file=${encodeURIComponent(this.ncUrl)}`;
    this.viewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    // 组织 object 方式url
    this.objectUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.ncUrl);
  }

  private switchToObjectMode() {
    this.useIframe = false;
    console.log(
      `%c 已切换到 object 模式加载 PDF `,
      `background:#67C23A;border:1px solid #67C23A; padding: 1px; border-radius: 2px; color: #fff;`
    );
  }
}
